module.exports = __webpack_public_path__ + "static/media/LaFourchette.2a3abf8b.png";